import React from 'react';
import './Hero.css'; // Import the CSS file for styles

const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-container" data-aos="fade-up">
        <h1 className="hero-title">Umami Database</h1>
      </div>
    </section>
  );
};

export default Hero;
